import type { Session } from '@supabase/supabase-js';
import { createContext } from 'react';

/**
 * Единый источник знания об идентичности пользователя.
 *
 * `unconfigured` замыкает диагностику ещё до обращения к Supabase — экраны
 * ниже по дереву не обязаны сами проверять isSupabaseConfigured.
 */
export type AuthStatus = 'unconfigured' | 'loading' | 'ready' | 'error';

export interface AuthState {
  status: AuthStatus;
  session: Session | null;
  /**
   * Готовый к показу текст, а не AuthError из supabase-js: вход по
   * подписи площадки (ADR-041) проваливается на сервере, и его причина
   * приходит в виде русского сообщения, которое в AuthError не уложить.
   * Отсутствует, когда показать человеку нечего, кроме общего текста.
   */
  error?: { message: string };
}

export const AuthContext = createContext<AuthState | null>(null);
